import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Auto from "./pages/Auto";
import Meubles from "./pages/Meubles";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Auto />} />
          <Route path="/meubles" element={<Meubles />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
